import React from "react";
import { FaUndoAlt, FaInfoCircle, FaEnvelope, FaClock } from "react-icons/fa";

const RefundPolicy = () => {
  const refundTerms = [
    {
      title: "General Donations",
      text: "Once a donation is made, it is generally non-refundable as it is immediately allocated to our projects, such as buying saplings for Ankuran Bandhan or raw materials for Aabharan Shakti.",
    },
    {
      title: "Error in Transaction",
      text: "If a duplicate deduction occurs or an incorrect amount is entered due to a technical error, the donor must notify us within 7 days of the transaction.",
    },
    {
      title: "Request Process",
      text: "To request a refund, please email us with your transaction details, proof of payment, and the reason for the request.",
      email: "finance@aabharan.org",
    },
  ];

  const notes = [
    "Refunds will be processed back to the original payment method within 10–15 working days after approval.",
    "If an 80G tax certificate has already been issued for the donation, we will be unable to process a refund as per Indian Tax Laws.",
  ];

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] py-14 px-4 sm:px-6 lg:px-8">
      <div className="absolute top-16 left-8 w-72 h-72 bg-[#1298b5]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-16 right-8 w-80 h-80 bg-[#f97316]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden border border-[#d8f4f8]">
        <div className="bg-gradient-to-r from-[#1298b5] to-[#0b819b] px-6 py-8 md:px-10 text-white">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-2xl mb-4">
            <FaUndoAlt />
          </div>

          <h1 className="text-3xl md:text-4xl font-extrabold">
            Refund Policy
          </h1>

          <p className="text-white/80 mt-2 text-sm">
            Transparent and fair donation refund guidelines.
          </p>
        </div>

        <div className="px-6 py-8 md:px-10 space-y-8">
          <p className="text-gray-700 leading-relaxed text-lg">
            Aabharan Foundation follows a transparent and fair refund policy. As
            a non-profit organization, we rely on donations to fund our social
            welfare programs.
          </p>

          <section>
            <h2 className="text-2xl font-extrabold text-[#073b4c] mb-5 border-b-2 border-[#d8f4f8] pb-3">
              Refund Terms
            </h2>

            <div className="space-y-4">
              {refundTerms.map((item, index) => (
                <div
                  key={index}
                  className="bg-[#f8fdfe] border border-[#d8f4f8] rounded-2xl p-5"
                >
                  <div className="flex items-start gap-3">
                    <span className="w-8 h-8 rounded-full bg-[#eafaff] text-[#1298b5] flex items-center justify-center flex-shrink-0 font-bold">
                      {index + 1}
                    </span>

                    <div>
                      <h3 className="font-bold text-[#073b4c] mb-1">
                        {item.title}
                      </h3>

                      <p className="text-gray-700 leading-relaxed">
                        {item.text}{" "}
                        {item.email && (
                          <a
                            href={`mailto:${item.email}`}
                            className="text-[#1298b5] hover:text-[#f97316] hover:underline font-semibold"
                          >
                            {item.email}
                          </a>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-extrabold text-[#073b4c] mb-5 border-b-2 border-[#d8f4f8] pb-3">
              Important Notes
            </h2>

            <div className="space-y-4">
              {notes.map((note, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 bg-white border border-[#d8f4f8] rounded-2xl p-5 shadow-sm"
                >
                  <FaInfoCircle className="text-[#1298b5] mt-1 flex-shrink-0" />
                  <p className="text-gray-700 leading-relaxed">{note}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="bg-gradient-to-br from-[#eafaff] to-white p-6 rounded-2xl border-l-4 border-[#1298b5]">
            <h2 className="text-xl font-extrabold text-[#073b4c] mb-4">
              Refund Request Support
            </h2>

            <div className="space-y-3 text-gray-700">
              <p className="flex items-center gap-3">
                <FaEnvelope className="text-[#1298b5]" />
                Email:{" "}
                <a
                  href="mailto:finance@aabharan.org"
                  className="text-[#1298b5] hover:text-[#f97316] hover:underline font-semibold"
                >
                  finance@aabharan.org
                </a>
              </p>

              <p className="flex items-center gap-3">
                <FaClock className="text-[#1298b5]" />
                Refund timeline: 10–15 working days after approval
              </p>
            </div>
          </section>

          <p className="text-xs text-gray-400 pt-4 border-t border-[#d8f4f8]">
            Last updated: March 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;